// extracted by mini-css-extract-plugin
export default {"container":"LectureItem_container__P1h9m","title":"LectureItem_title__XikRK"};